import React, { useEffect } from 'react';
import WhyChooseUs from '../components/resuableComponents/WhyChooseUs';
import Header from '../components/resuableComponents/Header';
import OurPortfolio from '../components/resuableComponents/OurPortfolio';
import FAQFormArea from '../components/resuableComponents/FAQFormArea';
import HeroSlider from '../components/resuableComponents/HeroSlider';
import Conversation from '../components/resuableComponents/Conversation';
import Stack from '../components/resuableComponents/Stack';
import IndustryWeWork from '../components/resuableComponents/IndustryWeWork';
import Slider from '../components/resuableComponents/Slider';
import ScrollingText from '../components/resuableComponents/ScrollingText';
import Footer from '../components/resuableComponents/Footer';
import { Box } from '@mui/material';
import SlickSlider from '../components/resuableComponents/SlickSlider';
import FloatingIcon from '../components/resuableComponents/FloatingIcon';
import Testimonial from '../components/resuableComponents/Testimonial';
import CanvasDotsAnimation from '../components/resuableComponents/CanvasDotsAnimation';
import FAQ from '../components/resuableComponents/FAQ';
import FloatingButton from '../components/resuableComponents/FloatingButton';

const LandingPage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div style={{ position: 'relative', overflow: 'hidden' }}>
		<div
		  style={{
			position: 'fixed',
			top: 0,
			left: 0,
			width: '100vw',
			height: '100vh',
			zIndex: 2, 
			pointerEvents: 'none', 
		  }}
		>
		  <CanvasDotsAnimation />
		</div>
  
		{/* Foreground Content */}
		<div style={{ position: 'relative', zIndex: 1 }}>
		  <Header />
		  <SlickSlider />
		  <ScrollingText />
		  <WhyChooseUs />
		  <FloatingIcon />
		  <Stack />
		  <IndustryWeWork />
		  <OurPortfolio />
		  <div style={{ background: '#F9F9F9', padding: 40, marginTop: 40 }}>
			<Conversation />
		  </div>
		  <FAQFormArea />
		  <Testimonial />
		  <FAQ/>
		  <Footer />
		  <FloatingButton/>
		</div>
	  </div>
	);
};

export default LandingPage;
